import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const FlagIcon = React.memo(function FlagIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 1.5V13.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 1.5H12.5L10 4.5L12.5 7.5H3.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 4.5H10"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
});
